import { Link } from "react-router-dom";
import { BookOpen, CalendarPlus, HelpCircle } from "lucide-react";
import Navbar from "@/components/Navbar";
import KnowledgeDirectory from "@/components/KnowledgeDirectory";
import { Button } from "@/components/ui/button";
import { organiserGuideSections } from "@/content/helpContent";

export default function OrganiserGuide() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="page-shell py-10 md:py-14">
        <header className="border-b border-border pb-8">
          <div className="flex items-center gap-2 text-primary">
            <BookOpen className="h-5 w-5" />
            <p className="text-xs font-black uppercase tracking-[0.25em]">Organiser handbook</p>
          </div>
          <div className="mt-3 flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
            <div>
              <h1 className="font-display text-3xl font-black md:text-5xl">Set up and run your event</h1>
              <p className="mt-3 max-w-3xl text-sm leading-6 text-muted-foreground md:text-base">
                Follow the full workflow from account verification and event review to ticket sales, reporting and door entry.
              </p>
            </div>
            <div className="flex flex-wrap gap-2">
              <Button asChild variant="outline" className="rounded-full"><Link to="/faq"><HelpCircle className="mr-2 h-4 w-4" />FAQ</Link></Button>
              <Button asChild className="rounded-full"><Link to="/create-event"><CalendarPlus className="mr-2 h-4 w-4" />Create event</Link></Button>
            </div>
          </div>
        </header>

        <section className="py-8">
          <KnowledgeDirectory sections={organiserGuideSections} placeholder="Search setup, tickets, Stripe, scanner or reports" />
        </section>
      </main>
    </div>
  );
}
